"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;
var _isArray = _interopRequireDefault(require("./isArray.js"));
var _setup = require("./_setup.js");
var _isString = _interopRequireDefault(require("./isString.js"));
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _map = _interopRequireDefault(require("./map.js"));
var _identity = _interopRequireDefault(require("./identity.js"));
var _values = _interopRequireDefault(require("./values.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Safely create a real, live array from anything iterable.
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray(obj) {
  if (!obj) return [];
  if ((0, _isArray.default)(obj)) return _setup.slice.call(obj);
  if ((0, _isString.default)(obj)) {
    // Keep surrogate pair characters together.
    return obj.match(reStrSymbol);
  }
  if ((0, _isArrayLike.default)(obj)) return (0, _map.default)(obj, _identity.default);
  return (0, _values.default)(obj);
}